// "Pakete gösterge ekle" › Seçim paneli: iki sekmenin birleşimi, kategoriye gruplu; her kalemde
// kaynak rozeti ("AI" / "Katalog") ve kaldır (×). Altında otomatik eklenecek sayısı.

import { useMemo } from "react";
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { selectionGroups } from "../../lib/kpi-package-add";
import type { DraftContext, PackagePick } from "../../lib/kpi-package-draft";
import { btnGhost, helpText, pillStyle } from "./kpi-form-styles";

const A = KPI_PACKAGES_COPY.add;

export interface PackageSelectionPanelProps {
  picks: readonly PackagePick[];
  ctx: DraftContext;
  autoCount: number;
  onRemove: (metricId: string) => void;
}

export function PackageSelectionPanel(p: PackageSelectionPanelProps): JSX.Element {
  const groups = useMemo(() => selectionGroups(p.picks, p.ctx, A.noCategory), [p.picks, p.ctx]);
  return (
    <section
      aria-label={A.selectionTitle}
      className="flex flex-col gap-2"
      style={{ minWidth: 0, minHeight: 0 }}
    >
      <h3 className="text-sm font-bold" style={{ margin: 0 }}>
        {A.selectionTitle} <span style={{ fontWeight: 400 }}>({p.picks.length})</span>
      </h3>
      <div style={{ overflowY: "auto", maxHeight: 380, minHeight: 0 }}>
        {groups.length === 0 ? (
          <p style={helpText}>{A.selectionEmpty}</p>
        ) : (
          groups.map((g) => (
            <div key={g.categoryId ?? "-"} className="mb-2">
              <div
                className="text-xs font-bold uppercase"
                style={{ color: "var(--color-text-2)", marginBottom: 2 }}
              >
                {g.label}
              </div>
              <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                {g.items.map((it) => {
                  const label = p.ctx.byId.get(it.metricId)?.label ?? it.metricId;
                  return (
                    <li
                      key={it.metricId}
                      className="flex items-center gap-2 text-sm"
                      style={{ minHeight: 32 }}
                      title={it.reason ?? undefined}
                    >
                      <span className="truncate" style={{ flex: 1, minWidth: 0 }}>
                        {label}
                      </span>
                      <span style={pillStyle}>
                        {it.source === "ai" ? A.sourceAi : A.sourceCatalog}
                      </span>
                      <button
                        type="button"
                        style={{ ...btnGhost, minHeight: 32, minWidth: 32, padding: 0 }}
                        aria-label={A.remove(label)}
                        onClick={() => p.onRemove(it.metricId)}
                      >
                        ×
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))
        )}
      </div>
      {p.autoCount > 0 ? <p style={helpText}>{A.autoNote(p.autoCount)}</p> : null}
    </section>
  );
}
